module.exports = __webpack_public_path__ + "assets/email-grey.87f8b385.svg";